import axios from 'axios';
import { getUser } from './Services/AuthService';

const trustedApiOrigins = [window.APP_SETTINGS.EXPERT_API_BASE_URL];

axios.interceptors.request.use(
  config => {
    const url = config.url || '';
    const isTrustedRequest = trustedApiOrigins.some(origin => url.startsWith(origin));

    const ua = navigator.userAgent;
    const isIE = ua.includes("MSIE ") || ua.includes("Trident/");

    // Add IE no-cache header
    if (isIE) {
      config.headers['If-Modified-Since'] = '0';
    }

    // Only attach Authorization header for trusted APIs
    if (isTrustedRequest) {
      return getUser()
        .then(user => {
          if (user?.access_token && !user.expired) {
            config.headers.Authorization = `Bearer ${user.access_token}`;
          }
          return config;
        })
        .catch(error => {
          console.log('Auth setup failed', error);
          return config;
        });
    }

    return config;
  },
  error => Promise.reject(error)
);
